const DEFAULT_AUTH_CALLBACK = "/onboarding";
const BLOCKED_PATHS = new Set(["/login", "/signup"]);

export function getSafeAuthCallbackUrl(value, fallback = DEFAULT_AUTH_CALLBACK) {
  const safeFallback = typeof fallback === "string" && fallback.startsWith("/")
    ? fallback
    : DEFAULT_AUTH_CALLBACK;

  if (typeof value !== "string" || !value.trim()) return safeFallback;

  const candidate = value.trim();
  if (!candidate.startsWith("/") || candidate.startsWith("//")) return safeFallback;

  try {
    const parsed = new URL(candidate, "https://jobolar.local");
    if (parsed.origin !== "https://jobolar.local") return safeFallback;
    if (parsed.pathname.startsWith("/api/") || parsed.pathname.startsWith("/_next/")) return safeFallback;
    if (BLOCKED_PATHS.has(parsed.pathname)) return safeFallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return safeFallback;
  }
}

export function getCurrentSafeAuthCallbackUrl() {
  if (typeof window === "undefined") return DEFAULT_AUTH_CALLBACK;
  return getSafeAuthCallbackUrl(
    `${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

export { DEFAULT_AUTH_CALLBACK };
